export * from './lib/tabs.component';
